import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["icon", "label"]

    connect() {
        this.applyTheme()
    }

    toggle() {
        const current = document.documentElement.getAttribute("data-theme")
        const next = current === "dark" ? "light" : "dark"
        document.documentElement.setAttribute("data-theme", next)
        localStorage.setItem("theme", next)
        this.updateUI(next)
    }

    applyTheme() {
        const saved = localStorage.getItem("theme") || "light"
        document.documentElement.setAttribute("data-theme", saved)
        this.updateUI(saved)
    }

    updateUI(theme) {
        if (this.hasIconTarget) {
            // Sun icon for dark (click to go light), Moon icon for light (click to go dark)
            this.iconTarget.innerHTML = theme === "dark"
                ? '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 7.66l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>'
                : '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"/>'
        }
        if (this.hasLabelTarget) {
            this.labelTarget.textContent = theme === "dark" ? "Light Mode" : "Dark Mode"
        }
    }
}
